/* eslint-disable */
const AdminHeader = () => {
    return (
        <div>
            <img src="/logos/bpsc-header.png" width="100%" alt=''/>
        </div>
    )
}

export default AdminHeader;